/*    
<summary>
   This functional common component provides us pagination functionality.
   Developer:Aashish Singh, Created Date:25-Aug-2022
</summary>
<returns>Returns JSX</returns>
*/
import React, { useEffect, useState } from 'react'
import { Pagination } from 'react-bootstrap'; 
import { Search } from 'react-bootstrap-icons';
import './Pagination.css';
import { formatMessage } from '../../translations/format-message';


type PropTypes = {
    totalPages: number;
    pageLimit: number;
    onPageChanged: Function
    disablePagination: boolean;
    isRefreshPage?: boolean;
    //setIsRefreshPage: Function;
}
const ApplicationPagger = (props: PropTypes) => {

    const [currentPage, setCurrentPage] = useState<number>(1);
    const [inputCurrentPage, setInputCurrentPage] = useState<number>(1);

    let { totalPages, pageLimit, onPageChanged, disablePagination, isRefreshPage } = props;
    if (totalPages === 0) {
        totalPages = 1;
    }
    const gotoPage = (page: number) => {
        const changedPage = Math.max(1, Math.min(page, totalPages));
        setCurrentPage(changedPage);
    }

    useEffect(() => {
        onPageChanged(1);
        setCurrentPage(1);
        setInputCurrentPage(1);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pageLimit])

    useEffect(() => {
        if (isRefreshPage) {
            setInputCurrentPage(1);
            setCurrentPage(1);
            //props.setIsRefreshPage();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isRefreshPage])

    useEffect(() => {
        onPageChanged(currentPage);
        setInputCurrentPage(currentPage)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage])

    useEffect(() => {
        gotoPage(1);
        setInputCurrentPage(1);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleCurrentPage = () => {
        gotoPage(inputCurrentPage);
    }

    const handleMoveFirst = (e: any) => {
        e.preventDefault();
        gotoPage(1);

    }

    const handleMoveLast = (e: any) => {
        e.preventDefault();
        gotoPage(totalPages);
    }

    const handleMoveNext = (e: any) => {
        e.preventDefault();
        gotoPage(currentPage + 1);
    }

    const handleMovePrev = (e: any) => {
        e.preventDefault();
        gotoPage(currentPage - 1);

    }

    const onInputPageChanged = (e: any) => {
        let numRegex = /^[0-9\b]+$/;
        if (e.target.value === '' || numRegex.test(e.target.value)) {
            setInputCurrentPage(e.target.value)
        }
    }

    const inputChanged = (e: any) => {
        if (e.target.value === "")
            setInputCurrentPage(currentPage);
    }

    return (
        <div className="panelTablePagination">
            <Pagination>
                <Pagination.First as="span" onClick={handleMoveFirst} title={formatMessage('first')} disabled={disablePagination || inputCurrentPage <= 1 || inputCurrentPage > totalPages } />
                <Pagination.Prev as="span" onClick={handleMovePrev} title={formatMessage('prev')} disabled={disablePagination || inputCurrentPage <= 1 || inputCurrentPage > totalPages} />
                <div className='customPages d-flex justify-content-center align-items-center'>
                    <span className='currentPage d-flex'>
                        <input type="text" name="currentPage" value={inputCurrentPage} className='pageInput' onChange={onInputPageChanged} onBlur={inputChanged} onKeyUp={(e) => {if (e.key === 'Enter' || e.keyCode === 13 || e.code == 'NumpadEnter') handleCurrentPage()}} />
                        <span title={formatMessage('search')} className={`${( inputCurrentPage <= totalPages && inputCurrentPage > 0)  ? "searchIcon" : "searchIcon disabled-class"} d-inline-flex align-items-center pr-4`} onClick={handleCurrentPage}><Search /> </span>
                    </span>
                    <span className='totalpages'> / {totalPages}</span>
                </div>
                <Pagination.Next as="span" data-testid="nextPage" title={formatMessage('next')} onClick={handleMoveNext} disabled={disablePagination || inputCurrentPage >= totalPages} />
                <Pagination.Last as="span" onClick={handleMoveLast} title={formatMessage('last')} disabled={disablePagination || inputCurrentPage >= totalPages || inputCurrentPage < 1} />

            </Pagination>
        </div>

    )
}

export default ApplicationPagger;